import { useContext, useEffect, useRef, useState } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import ELoader from '@educaplay/app-core/components/ELoader';
import OutsideAlerter from '../elements/OutsideAlerter';
import { SVG_close } from '../elements/SVG';

const TITLE_ID = 'supportArticleTitle';

export const ModalSupportArticle = () => {

    const { appReducer, environment } = useContext( MainContext );
    const licenseId = appReducer.state.modals.supportArticle;
    const urls = environment.knowMoreUrls[licenseId] ?? {};
    const [status, setStatus] = useState('loading');
    const [html, setHtml] = useState('');
    const bodyRef = useRef(null);

    useEffect(() => {
        if (!urls.fragment) {
            setStatus('error');
            return undefined;
        }
        const controller = new AbortController();
        setStatus('loading');
        fetch(urls.fragment, { signal: controller.signal })
            .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
            .then((text) => {
                setHtml(text);
                setStatus('ready');
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setStatus('error');
                }
            });
        return () => controller.abort();
    }, [urls.fragment]);

    useEffect(() => {
        bodyRef.current?.querySelectorAll('a[href]').forEach((link) => {
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
        });
    }, [html]);

    const handleClose = () => {
        appReducer.dispatch({
            type: 'closeModal',
            payload: 'supportArticle'
        });
    }

    return  <>
            <div className="e__modal">
                <OutsideAlerter action={ handleClose }>
                <div className="e__modal__art" role="dialog" aria-modal="true" aria-labelledby={TITLE_ID}>
                    <button aria-label={ getText('cerrar') } className="e-btn e-btn--transparent" onClick={ handleClose }><span className="e-icon"><SVG_close /></span></button>
                    <div className="e__modal__art__wpr">
                        <h2 id={TITLE_ID} className="e__modal__art__hd">{ getText('plan_educaplay') } { getText('plan_name_' + licenseId) }</h2>
                        {(status === 'loading') && <div className="e__modal__art__ldr"><ELoader /></div>}
                        {(status === 'error') && <p className="e__modal__art__msg">{ getText('article_error') }</p>}
                        {(status === 'ready') && <div ref={bodyRef} dangerouslySetInnerHTML={{ __html: html }} />}
                        {urls.page &&
                            <div className="e__modal__art__ft">
                                <a className="e-btn e-btn--secondary" href={ urls.page } target="_blank" rel="noopener noreferrer">
                                    <span className="e-btn__txt">{ getText('article_link') }</span>
                                </a>
                            </div>
                        }
                    </div>
                </div>
                </OutsideAlerter>
                <div className="e__modal__bckg"></div>
            </div>
            </>;

}
